<template>
  <ContentSection 
    v-if="label"
    :id="sectionId"
    wide>
    <SectionHeader v-if="label" :label="label" />
    
    <Tags :tags="partijen" />

    <h3 v-if="title && ! titleIsLabel">
      {{ title }}
    </h3>

    <TimeLineSegmentContent 
      v-for="content in contentSegments" 
      :key="content.id"
      :content="content" />

    <Tags :tags="themas" />

  </ContentSection>
</template>

<script>

import {
  convertDateObjectToDutchMonthYearString,
  convertDateStringToDate
} from '@/helpers/date'
import dynamicSort from '@/helpers/dynamicSort';

import SectionHeader from '@/components/section/Header';
import ContentSection from '@/components/section/ContentSection';
import TimeLineSegmentContent from '@/components/section/TimeLineSegmentContent';
import Tags from '@/components/lists/Tags';

export default {
  name: 'TimeLineSegment',
  components: {
    SectionHeader,
    ContentSection,
    TimeLineSegmentContent,
    Tags
  },
  props: {
    segment: {
      type: Object,
      required: true
    }
  },
  computed: {
    contentSegments() {
      return this.$store.getters.getSegmentContentsByHeaderId({
        id: this.segment.id
      }).sort(dynamicSort('prio'));
    },
    title() {
      return this.segment.header || false;
    },
    label() {
      // Prefer an exact label
      if (this.segment.label && this.segment.label !== '') {
        return this.segment.label;
      }

      // Otherwise check for a date
      if (this.segment.date) {
        return convertDateObjectToDutchMonthYearString(
          convertDateStringToDate(this.segment.date)
        );
      }
      
      // fallback to a title. 
      // If false, do not show the segment divider.
      return this.title;
    },
    sectionId() {
      if (this.segment.date !== '') {
        return 'section_'+this.segment.date
      }
      return '';
    },
    titleIsLabel() {
      return (this.title === this.label);
    },
    tags() {
      return this.partijen.concat(this.themas);
    },
    partijen() {
      let tags = [];
      let items = this.segment.partijen;
      let vm = this;

      if (items) {
        items.forEach((item) => {
          item = vm.$store.getters.getPartijById({id: item});
          if (item) {
            tags.push(item); 
          }
        });
      }

      return tags
        .filter((v, i, a) => a.indexOf(v) === i) // unique
    },
    themas() {
      let tags = [];
      let items = this.segment.themas;
      let vm = this;
      if (items) {
        items.forEach((item) => {
          item = vm.$store.getters.getThemaById({id: item});
          if (item) {
            item.type = 'thema';
            tags.push(item); 
          }
        });
      }

      return tags
        .filter((v, i, a) => a.indexOf(v) === i) // unique
    },
  }
}
</script>
